module.exports = __webpack_public_path__ + "media/images/icon_chat-83baa626b17c234e7dc167b20ee9f9a3.svg";